import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { useStore } from "vuex";
import { computed } from "vue";

import ButtonStrip from "@/components/UI/ButtonStrip.vue";
import ButtonPrimitive from "@/components/UI/ButtonPrimitive.vue";
import MeasurementsHeightTransition from "@/components/UI/MeasurementsHeightTransition.vue";
import DrillHoleEdgeTypes from "@/components/DrillHoleEdgeTypes.vue";
import DrillHoleCustom from "@/components/DrillHoleCustom.vue";
import DrillHoleRadialSettings from "@/components/DrillHoleRadialSettings.vue";
import DrillHoleGridSettings from "@/components/DrillHoleGridSettings.vue";
import DrillHolePreset from "@/components/DrillHolePreset.vue";
import ValidationMessage from "@/components/UI/ValidationMessage.vue";
import MessageContainer from "@/components/UI/MessageContainer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DrillHoles',
  setup(__props) {


const store = useStore();

const $i18n = window.measurementSelectorVariables.i18n;

const drillOption = computed(() => store.getters.drillOption );
const shape = computed(() => store.getters.shape );
const primitives = computed(() => store.getters.primitives );
const canUseExactCenter = computed(() => store.getters.canUseExactCenter );
const usesDefaultDrillHoleDimensions = computed(() => store.getters.usesDefaultDrillHoleDimensions );
const drillHoleSelectorButtons = computed(() => store.getters.drillHoleSelectorButtons );
const isCenteredDrillHoles = computed(() => [ 'none', 'custom', 'edges' ].includes( drillOption.value ) );
const activeItemIndex = computed(() => {
	const index = drillHoleSelectorButtons.value.findIndex( ( item: {
		active: boolean;
	} )=> item.active === true);

	return index === -1 ? 0 : index;
});
const showCenterOfShapeNotice = computed(() =>
	canUseExactCenter.value === false
	&& isCenteredDrillHoles.value
	&& usesDefaultDrillHoleDimensions.value === true
);
const showDrillHolesNotice = computed(() =>
	drillOption.value !== 'none'
	&& drillOption.value !== 'radial'
	&& drillOption.value !== 'grid'
	&& drillOption.value !== 'edges'
);

function updateDrillOption( option: string ) {
	store.commit("updateDrillOption", option );
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ButtonStrip, {
      "total-buttons": drillHoleSelectorButtons.value.length,
      "buttons-per-row": 5,
      "selected-item": activeItemIndex.value
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drillHoleSelectorButtons.value, (item, index) => {
          return (_openBlock(), _createBlock(ButtonPrimitive, {
            "on-click": () => updateDrillOption(item.selection),
            icon: item.icon,
            text: item.text,
            index: index,
            "is-active": item.selection === drillOption.value
          }, null, 8, ["on-click", "icon", "text", "index", "is-active"]))
        }), 256))
      ]),
      _: 1
    }, 8, ["total-buttons", "selected-item"]),
    _createVNode(MeasurementsHeightTransition, {
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (drillOption.value === 'edges')
          ? (_openBlock(), _createBlock(DrillHoleEdgeTypes, {
              key: 0,
              shape: shape.value,
              primitives: primitives.value
            }, null, 8, ["shape", "primitives"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MeasurementsHeightTransition, {
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (drillOption.value === 'custom')
          ? (_openBlock(), _createBlock(DrillHoleCustom, {
              key: 0,
              shape: shape.value,
              primitives: primitives.value
            }, null, 8, ["shape", "primitives"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MeasurementsHeightTransition, {
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (drillOption.value === 'radial')
          ? (_openBlock(), _createBlock(DrillHoleRadialSettings, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MeasurementsHeightTransition, {
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (drillOption.value === 'grid')
          ? (_openBlock(), _createBlock(DrillHoleGridSettings, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MeasurementsHeightTransition, {
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (drillOption.value === 'preset')
          ? (_openBlock(), _createBlock(DrillHolePreset, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MessageContainer, null, {
      default: _withCtx(() => [
        (showDrillHolesNotice.value)
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 0,
              type: "notice"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($i18n).drillHolesNotice), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (showCenterOfShapeNotice.value)
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 1,
              type: "notice"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($i18n).centerOfShapeNotice), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})